/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Library_AnswerInputs */

const en_landing_faq_library_answer = /** @type {(inputs: Landing_Faq_Library_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inginuiti sits as an AI-native layer over your firm's existing research library. It converts your PDF archives into a searchable, real-time data environment, so every piece of your team's work, published today or two years ago, stays discoverable at the front office's fingertips.`)
};

/**
* | output |
* | --- |
* | "Inginuiti sits as an AI-native layer over your firm's existing research library. It converts your PDF archives into a searchable, real-time data environment,..." |
*
* @param {Landing_Faq_Library_AnswerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_library_answer = /** @type {((inputs?: Landing_Faq_Library_AnswerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Library_AnswerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_library_answer(inputs)
});